<div class="input-wrapper text-sm">
  <div class="icon2-x16-search"></div>
  <input
    #inputSearch
    [class.clear-button]="localValue"
    class="input"
    type="text"
    name="{{ name }}"
    placeholder="{{ placeholder }}"
    [attr.disabled]="readonly"
    [(ngModel)]="localValue"
    (ngModelChange)="change()"
  />
  <div *ngIf="localValue" (click)="clear()" class="icon2-x16-close-s"></div>
</div>
